/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetAbout200Response,
  GetCommonState400Response,
  GetContacts200Response,
  GetDocuments200Response,
  GetHome200Response,
  GetInstruction404Response,
  GetSitemap200Response,
} from '../models/index'
import {
  GetAbout200ResponseFromJSON,
  GetAbout200ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetContacts200ResponseFromJSON,
  GetContacts200ResponseToJSON,
  GetDocuments200ResponseFromJSON,
  GetDocuments200ResponseToJSON,
  GetHome200ResponseFromJSON,
  GetHome200ResponseToJSON,
  GetInstruction404ResponseFromJSON,
  GetInstruction404ResponseToJSON,
  GetSitemap200ResponseFromJSON,
  GetSitemap200ResponseToJSON,
} from '../models/index'

/**
 * PageApi - interface
 *
 * @export
 * @interface PageApiInterface
 */
export interface PageApiInterface {
  /**
   * Контент страницы «О компании» (o-kompanii): команда. Ответ кэшируется в Redis.
   * @summary Контент страницы «О компании»
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PageApiInterface
   */
  getAboutRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetAbout200Response>>

  /**
   * Контент страницы «О компании» (o-kompanii): команда. Ответ кэшируется в Redis.
   * Контент страницы «О компании»
   */
  getAbout(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetAbout200Response>

  /**
   * Контент страницы «Контакты» (contacts): группа настроек site_options. Ответ кэшируется в Redis.
   * @summary Контент страницы «Контакты»
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PageApiInterface
   */
  getContactsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetContacts200Response>>

  /**
   * Контент страницы «Контакты» (contacts): группа настроек site_options. Ответ кэшируется в Redis.
   * Контент страницы «Контакты»
   */
  getContacts(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetContacts200Response>

  /**
   * Контент страницы «Документы» (documents): файлы документов. Ответ кэшируется в Redis.
   * @summary Контент страницы «Документы»
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PageApiInterface
   */
  getDocumentsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetDocuments200Response>>

  /**
   * Контент страницы «Документы» (documents): файлы документов. Ответ кэшируется в Redis.
   * Контент страницы «Документы»
   */
  getDocuments(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetDocuments200Response>

  /**
   * Контент главной страницы (main): блок статей блога. Ответ кэшируется в Redis.
   * @summary Контент главной страницы
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PageApiInterface
   */
  getHomeRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetHome200Response>>

  /**
   * Контент главной страницы (main): блок статей блога. Ответ кэшируется в Redis.
   * Контент главной страницы
   */
  getHome(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetHome200Response>

  /**
   * Карта сайта (sitemap). Ответ кэшируется в Redis.
   * @summary Карта сайта
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PageApiInterface
   */
  getSitemapRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetSitemap200Response>>

  /**
   * Карта сайта (sitemap). Ответ кэшируется в Redis.
   * Карта сайта
   */
  getSitemap(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetSitemap200Response>
}

/**
 *
 */
export class PageApi extends runtime.BaseAPI implements PageApiInterface {
  /**
   * Контент страницы «О компании» (o-kompanii): команда. Ответ кэшируется в Redis.
   * Контент страницы «О компании»
   */
  async getAboutRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetAbout200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/pages/o-kompanii`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetAbout200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Контент страницы «О компании» (o-kompanii): команда. Ответ кэшируется в Redis.
   * Контент страницы «О компании»
   */
  async getAbout(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetAbout200Response> {
    const response = await this.getAboutRaw(initOverrides)
    return await response.value()
  }

  /**
   * Контент страницы «Контакты» (contacts): группа настроек site_options. Ответ кэшируется в Redis.
   * Контент страницы «Контакты»
   */
  async getContactsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetContacts200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/pages/contacts`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetContacts200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Контент страницы «Контакты» (contacts): группа настроек site_options. Ответ кэшируется в Redis.
   * Контент страницы «Контакты»
   */
  async getContacts(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetContacts200Response> {
    const response = await this.getContactsRaw(initOverrides)
    return await response.value()
  }

  /**
   * Контент страницы «Документы» (documents): файлы документов. Ответ кэшируется в Redis.
   * Контент страницы «Документы»
   */
  async getDocumentsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetDocuments200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/pages/documents`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetDocuments200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Контент страницы «Документы» (documents): файлы документов. Ответ кэшируется в Redis.
   * Контент страницы «Документы»
   */
  async getDocuments(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetDocuments200Response> {
    const response = await this.getDocumentsRaw(initOverrides)
    return await response.value()
  }

  /**
   * Контент главной страницы (main): блок статей блога. Ответ кэшируется в Redis.
   * Контент главной страницы
   */
  async getHomeRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetHome200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/pages/main`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetHome200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Контент главной страницы (main): блок статей блога. Ответ кэшируется в Redis.
   * Контент главной страницы
   */
  async getHome(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetHome200Response> {
    const response = await this.getHomeRaw(initOverrides)
    return await response.value()
  }

  /**
   * Карта сайта (sitemap). Ответ кэшируется в Redis.
   * Карта сайта
   */
  async getSitemapRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetSitemap200Response>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/pages/sitemap`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetSitemap200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Карта сайта (sitemap). Ответ кэшируется в Redis.
   * Карта сайта
   */
  async getSitemap(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetSitemap200Response> {
    const response = await this.getSitemapRaw(initOverrides)
    return await response.value()
  }
}
